var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05391 15.1487C2.58162 15.1487 2.17917 14.9824 1.84656 14.6497C1.51396 14.3171 1.34766 13.9147 1.34766 13.4424V4.55002C1.34766 4.07773 1.51397 3.67528 1.84659 3.34267C2.17919 3.01006 2.58164 2.84375 3.05392 2.84375H14.9463C15.4186 2.84375 15.821 3.01006 16.1536 3.34267C16.4863 3.67528 16.6526 4.07773 16.6526 4.55002V13.4424C16.6526 13.9147 16.4863 14.3171 16.1536 14.6497C15.821 14.9824 15.4186 15.1487 14.9463 15.1487H3.05391ZM9.00009 9.93901L3.05391 6.18901V13.4424H14.9463V6.18901L9.00009 9.93901ZM9.00009 8.30002L14.9463 4.55002H3.05391L9.00009 8.30002ZM3.05391 6.18901V4.55002V13.4424V6.18901Z",
    fill: "#909092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.e61e7fdb26ebf92cc52ceaee008252a8.svg";
export { ForwardRef as ReactComponent };